const properties = [
  {
    id: 1,
    slug: "the-graham-tse-addo",

    title: "The Graham",
    location: "Tse Addo, Accra",

    category: "Luxury Apartment",
    status: "Available",

    price: "Price on Request",
    priceLabel: "Starting From",

    coverImage: "/images/graham1.jpg",

    excerpt:
      "A refined residential development in Tse Addo offering contemporary architecture, spacious interiors and modern comfort.",

    description:
      "The Graham is a premium residential property located in Tse Addo, Accra. Designed for modern families and professionals, the development combines elegant architecture, generous living spaces and contemporary finishes in a peaceful residential environment.",

    bedrooms: 4,
    bathrooms: 5,

    features: [
      "4 spacious bedrooms",
      "Modern fitted kitchen",
      "Large living and dining area",
      "Premium bathroom finishes",
      "Secure residential environment",
      "Ample parking space",
      "Modern architectural design",
      "Excellent location in Tse Addo",
    ],

    images: [
      "/images/graham1.jpg",
      "/images/graham2.jpg",
      "/images/graham3.jpg",
      "/images/graham4.jpg",
      "/images/graham5.jpg",
      "/images/graham6.jpg",
      "/images/grahaminterior1.jpg",
      "/images/grahaminterior2.jpg",
      "/images/grahaminterior3.jpg",
      "/images/grahaminterior4.jpg",
    ],

    publishedAt: "2026-08-25",

    featured: true,
  },

  {
    id: 2,
    slug: "smart-homes-tse-addo",

    title: "Modern Smart Homes",
    location: "Tse Addo, Accra",

    category: "House for Sale",
    status: "Available",

    price: "Price on Request",
    priceLabel: "Starting From",

    coverImage: "/images/solosec1.jpg",

    excerpt:
      "Contemporary smart homes designed for buyers seeking technology, comfort and modern residential living in Accra.",

    description:
      "These modern smart homes combine elegant architecture with contemporary technology to create a comfortable and efficient living environment. They are ideal for families, professionals and property investors looking for quality residential opportunities in Accra.",

    bedrooms: 4,
    bathrooms: 4,

    features: [
      "Smart home technology",
      "Contemporary architecture",
      "Spacious bedrooms",
      "Modern fitted kitchen",
      "Premium interior finishes",
      "Secure environment",
      "Private parking",
      "Excellent residential location",
    ],

    images: [
      "/images/solosec1.jpg",
      "/images/solo2.jpg",
      "/images/solo3.jpg",
      "/images/solo4.jpg",
      "/images/solo5.jpg",
      "/images/solo6.jpg",
      "/images/solo7.jpg",
      "/images/solo8.jpg",
    ],

    publishedAt: "2026-08-22",

    featured: false,
  },

  {
    id: 3,
    slug: "four-bedroom-home-tse-addo",

    title: "4 Bedroom Home",
    location: "Tse Addo, Accra",

    category: "House for Sale",
    status: "Available",

    price: "$480,000",
    priceLabel: "Asking Price",

    coverImage: "/images/tse1.jpeg",

    excerpt:
      "A beautifully designed four-bedroom family residence offering generous living spaces in the heart of Tse Addo.",

    description:
      "This four-bedroom residence is designed for families and professionals looking for spacious modern living. The property offers generous interiors, contemporary finishes and convenient access to key areas within Accra.",

    bedrooms: 4,
    bathrooms: 4,

    features: [
      "4 bedrooms",
      "Spacious living room",
      "Modern kitchen",
      "Dining area",
      "Contemporary bathrooms",
      "Private parking",
      "Secure environment",
      "Prime Tse Addo location",
    ],

    images: [
      "/images/tse1.jpeg",
      "/images/tse2.jpeg",
      "/images/tse3.jpeg",
      "/images/tse4.jpeg",
    ],

    publishedAt: "2026-08-18",

    featured: false,
  },

  {
    id: 4,
    slug: "five-bedroom-luxury-residence",

    title: "5 Bedroom Luxury Residence",
    location: "Accra, Ghana",

    category: "Luxury House",
    status: "Available",

    price: "Price on Request",
    priceLabel: "Asking Price",

    coverImage: "/images/un1.png",

    excerpt:
      "A spacious five-bedroom residence created for sophisticated family living with elegant finishes and generous interiors.",

    description:
      "This luxury five-bedroom residence offers impressive interior space, contemporary architectural detailing and carefully designed living areas suited to modern family life.",

    bedrooms: 5,
    bathrooms: 5,

    features: [
      "5 bedrooms",
      "Large living spaces",
      "Contemporary design",
      "Modern kitchen",
      "Premium finishes",
      "Private parking",
      "Secure residential setting",
      "Family-friendly layout",
    ],

    images: [
      "/images/un1.png",
      "/images/un2.png",
      "/images/un3.png",
    ],

    publishedAt: "2026-08-15",

    featured: false,
  },

  {
    id: 5,
    slug: "burma-hills-home-for-rent",

    title: "Premium Home for Rent",
    location: "Burma Hills, Tse Addo",

    category: "House for Rent",
    status: "Available",

    price: "Contact for Rent",
    priceLabel: "Monthly Rent",

    coverImage: "/images/redsolonetrent.png",

    excerpt:
      "A premium rental residence at Burma Hills offering comfort, security and excellent access to surrounding areas.",

    description:
      "Located at Burma Hills in Tse Addo, this premium rental home is suited to families and professionals looking for a secure, spacious and comfortable residential environment.",

    bedrooms: 3,
    bathrooms: 3,

    features: [
      "3 bedrooms",
      "Fitted kitchen",
      "Maids / storage room",
      "Free water supply",
      "Standby generator",
      "24/7 security service",
      "Electric fencing",
      "CCTV surveillance",
      "Ample parking space",
      "Spacious living and dining areas",
    ],

    images: [
      "/images/redsolonetrent.png",
      "/images/A.png",
      "/images/B.png",
      "/images/C.png",
      "/images/D.png",
      "/images/E.png",
      "/images/F.png",
      "/images/G.png",
      "/images/H.png",
    ],

    video: "/videos/compred.mp4",

    publishedAt: "2026-08-10",

    featured: false,
  },
];

export default properties;